import { useLazyQuery } from '@apollo/react-hooks';
import {
  FacebookAdsWithInsightsQuery,
  FacebookAdsWithInsightsQueryVariables
} from './__generated__/FacebookAdsWithInsightsQuery';
import { kmsClient } from 'api';
import { FACEBOOK_ADS_WITH_INSIGHTS_QUERY } from './facebookAdsWithInsights.query';

export const useFacebookAdsWithInsightsLazyQuery = () => {
  return useLazyQuery<FacebookAdsWithInsightsQuery, FacebookAdsWithInsightsQueryVariables>(
    FACEBOOK_ADS_WITH_INSIGHTS_QUERY,
    {
      client: kmsClient,
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: true
    }
  );
};
